// Syllable Division — multi-syllable words with the correct split position(s).
// `divisions` = 0-based letter index AFTER which the word splits.
// e.g. RABBIT splits after index 2 (RAB|BIT) so divisions = [3].
export const SYLLABLE_ITEMS = [
  { word: "RABBIT", divisions: [3], pattern: "VC/CV", note: "Split between double consonants." },
  { word: "TIGER", divisions: [2], pattern: "V/CV", note: "Open syllable — vowel says its name." },
  { word: "NAPKIN", divisions: [3], pattern: "VC/CV", note: "Split between the two consonants." },
  { word: "BASKET", divisions: [3], pattern: "VC/CV", note: "Split between the two consonants." },
  { word: "MUFFIN", divisions: [3], pattern: "VC/CV", note: "Split between double consonants." },
  { word: "PILOT", divisions: [2], pattern: "V/CV", note: "Long vowel — open first syllable." },
  { word: "ROBOT", divisions: [2], pattern: "V/CV", note: "Long o — open first syllable." },
  { word: "LEMON", divisions: [3], pattern: "VC/V", note: "Short vowel — closed first syllable." },
  { word: "WAGON", divisions: [3], pattern: "VC/V", note: "Short a — closed first syllable." },
  { word: "COMET", divisions: [3], pattern: "VC/V", note: "Short o — closed first syllable." },
  { word: "SUNSET", divisions: [3], pattern: "VC/CV", note: "Between the two consonants." },
  { word: "PICNIC", divisions: [3], pattern: "VC/CV", note: "Between the two consonants." },
];
